module.exports = __webpack_public_path__ + "img/England.fe7dd61c.png";